@use 'tokens.module' as t;

.informationText {
  background-color: #efefef;
  border-radius: 16px;
  color: rgba(0, 0, 0, 0.6);
  display: inline-block;
  font-size: 13px;
  font-weight: t.$font-weight-regular;
  line-height: 1.6;
  margin-bottom: 5px;
  margin-right: 5px;
  padding: 8px 12px;
}
